import { Component, Input } from '@angular/core';
import { TruckJourneyDelivery } from '../../models/truck-journey.model';

@Component({
  selector: 'app-hidden-deliveries-tooltip',
  templateUrl: './hidden-deliveries-tooltip.component.html',
  styleUrls: ['./hidden-deliveries-tooltip.component.scss']
})
export class HiddenDeliveriesTooltipComponent {
  @Input() public hiddenDeliveries: TruckJourneyDelivery[];
}
